import { extractAttributes } from '../extractAttributes/extractAttributes.js';

var getDataAttributes = function getDataAttributes(source) {
  var _extractAttributes = extractAttributes(source, RegExp('data-')),
    dataAttributes = _extractAttributes.extractedAttributes,
    rest = _extractAttributes.rest;
  return {
    dataAttributes: dataAttributes,
    rest: rest
  };
};

export { getDataAttributes };
//# sourceMappingURL=getDataAttributes.js.map
